import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/svgs/check-circle.svg';
import _imports_1 from '@/assets/svgs/close.svg';
const _hoisted_1 = {
  class: "success-modal-wrapper"
};
import { useRouter } from "vue-router";
export default /*@__PURE__*/Object.assign({
  name: "SuccessfulPage"
}, {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const handleClose = () => {
      router.push("/");
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("main", {
        class: "main-content"
      }, [_cache[1] || (_cache[1] = _createStaticVNode("<div class=\"success-modal-box\" data-v-222e8944><div class=\"success-modal-icon\" data-v-222e8944><img src=\"" + _imports_0 + "\" alt=\"success\" data-v-222e8944></div><div class=\"success-modal-title\" data-v-222e8944>Payment Successful!</div><div class=\"success-modal-desc\" data-v-222e8944> Your Diamond Yearly subscription is now active. To enjoy the services, please check your email for the credentials to log in to Trucker Path. </div></div>", 1)), _createElementVNode("div", {
        class: "success-modal-close",
        onClick: handleClose
      }, _cache[0] || (_cache[0] = [_createElementVNode("img", {
        src: _imports_1,
        alt: "close"
      }, null, -1)]))])]);
    };
  }
});